<template>
  <div style="padding: 10px 14px">
    <h3>教育课程云组织服务协议</h3>
    <p>更新及生效日期：2025年10月1日</p>
    <p>导言</p>
    <p>欢迎您使用东莞市安道光电材料制造有限公司（以下简称“安道教育”或“我司”）推出的教育课程云（以下简称“本平台”）。</p>
    <p>
      为了更好地为您提供服务，请您仔细阅读《教育课程云组织服务协议》（以下简称“本协议”）。本协议是客户（以下简称“您”）与“安道教育”就您登录、使用（以下统称“使用”）本平台所订立的协议，本服务协议具有合同同等效力。
    </p>
    <p>
      为了明确协议双方的权力与义务，请您在开始使用本平台之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用增值服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。如您不同意本协议，我司将无法为您提供服务，您可以选择停止使用。如您选择使用本平台，则视为您已充分理解本协议，并同意作为本协议的当事人，接受本协议以及其他相关配套协议和规则（包括但不限于《隐私政策》）的约束。
    </p>
    <p>
      我司有权根据需要不时制订、修改本协议及相关规则，变更后的协议和规则将通过本平台的通知公告，提前向您传达及公示，公示完毕后即取代原协议及规则生效。如您不同意相关变更，应立即停止使用本平台；如您继续使用即表示您已接受经修订后的协议和规则。
    </p>

    <strong>
      <p>第一章 总则</p>
    </strong>
    <p>1.1 本协议适用于已注册并正常使用个人账户的用户，通过提交相关证明材料申请创建组织账户的行为。</p>
    <p>1.2 组织账户的申请者必须是该组织的合法授权代表，且需确保提供的所有信息和材料真实、准确、完整。</p>
    <p>1.3 组织账户创建后，原个人账户将作为该组织账户的管理员账户，享有组织管理权限。</p>

    <strong>
      <p>第二章 账户申请与审核</p>
    </strong>
    <p>2.1 您理解并同意，提交组织账户申请并不代表自动获得批准，我们有权对您提交的证明材料进行审核，并有权要求补充提供其他相关材料。</p>
    <p>2.2 审核期间，我们可能会通过电话、邮件等方式与您联系，核实组织信息和申请真实性，请确保联系方式准确有效。</p>
    <p>2.3 若申请审核通过，您将获得组织账户的管理权限；若未通过审核，我们将通过站内信或邮件告知原因。</p>

    <strong>
      <p>第三章 账户权限与管理</p>
    </strong>
    <p>3.1 组织账户管理员有权邀请其他成员加入组织，并为其分配相应权限。</p>
    <p>3.2 管理员需确保组织成员均获得相应授权，并对其在组织账户下的所有操作承担管理责任。</p>
    <p>3.3 组织账户下的资源使用行为均视为组织行为，由组织及其管理员承担相应责任。</p>

    <strong>
      <p>第四章 知识产权</p>
    </strong>
    <p>4.1 组织账户下产生的原创内容，知识产权归属按照相关法律法规及组织内部规定确定。</p>
    <p>4.2 我们仅提供技术服务，不享有组织账户下用户上传的原创内容的知识产权。</p>

    <strong>
      <p>第五章 免责声明</p>
    </strong>
    <p>5.1 您保证拥有申请组织账户的合法授权，如因授权问题产生纠纷，由您自行承担全部责任。</p>
    <p>5.2 因组织内部管理不善导致的账户纠纷或损失，我们不承担任何责任。</p>

    <strong>
      <p>第六章 协议变更与终止</p>
    </strong>
    <p>6.1 我们有权根据法律法规变化或业务调整需要修改本协议，修改后的协议将通过适当方式公布。</p>
    <p>6.2 如发现组织账户存在违规使用情况，我们有权暂停或终止提供服务。</p>

    <strong>
      <p>第七章 通知及联系方式</p>
    </strong>
    <p>7.1 我司将通过平台公告、客户电话等方式向您传达重要消息。</p>
    <p>7.2 如有疑问、建议或投诉，可通过以下方式联系我司：</p>
    <P>公司：{{ activationCompany.company }}</P>
    <P>电话：400-632-8880</P>
    <P>联系人：客服专员</P>
    <P>地址：{{ activationCompany.address }}</P>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
}
</style>
